var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "system-config" },
    [
      _c(
        "el-tabs",
        { attrs: { type: "border-card" } },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "小程序配置" } },
            [
              _c(
                "el-form",
                {
                  staticClass: "setting-form",
                  attrs: {
                    model: _vm.miniapp,
                    rules: _vm.miniRules,
                    size: "medium",
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "appId", prop: "appid" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入 appId", clearable: "" },
                        model: {
                          value: _vm.miniapp.appid,
                          callback: function ($$v) {
                            _vm.$set(_vm.miniapp, "appid", $$v)
                          },
                          expression: "miniapp.appid",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "appSecret", prop: "secret" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入 appSecret",
                          clearable: "",
                        },
                        model: {
                          value: _vm.miniapp.secret,
                          callback: function ($$v) {
                            _vm.$set(_vm.miniapp, "secret", $$v)
                          },
                          expression: "miniapp.secret",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "小程序名称", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入小程序名称",
                          clearable: "",
                        },
                        model: {
                          value: _vm.miniapp.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.miniapp, "name", $$v)
                          },
                          expression: "miniapp.name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "跳转到新小程序" } },
            [
              _c(
                "el-form",
                {
                  staticClass: "setting-form",
                  attrs: {
                    model: _vm.upgrade,
                    rules: _vm.upgradeRules,
                    size: "medium",
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "appId", prop: "appId" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入 appId", clearable: "" },
                        model: {
                          value: _vm.upgrade.appId,
                          callback: function ($$v) {
                            _vm.$set(_vm.upgrade, "appId", $$v)
                          },
                          expression: "upgrade.appId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "要打开的版本", prop: "envVersion" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择要打开的小程序版本",
                            clearable: "",
                          },
                          model: {
                            value: _vm.upgrade.envVersion,
                            callback: function ($$v) {
                              _vm.$set(_vm.upgrade, "envVersion", $$v)
                            },
                            expression: "upgrade.envVersion",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "开发版", value: "develop" },
                          }),
                          _c("el-option", {
                            attrs: { label: "体验版", value: "trial" },
                          }),
                          _c("el-option", {
                            attrs: { label: "正式版", value: "release" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-form",
        {
          staticClass: "button-form",
          attrs: { size: "medium", "label-width": "135px" },
        },
        [
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                [_vm._v("提交保存")]
              ),
              _c("el-button", [_vm._v("取消")]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }